'use client';

import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import Image from 'next/image';

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
  { label: 'How It Works', href: '#how-it-works' },
  { label: 'Cruises', href: '#cruises' },
  { label: 'Testimonials', href: '#testimonials' },
  { label: 'About', href: '#about' },
  { label: 'Contact', href: '#contact' }];


  return (
    <header
      className={`relative z-50 transition-all duration-500 bg-navy-dark/95 backdrop-blur-md shadow-2xl py-3`}
      >
      
      <div className="max-w-7xl mx-auto px-6 flex items-center justify-between">
        {/* Logo */}
        <Link href="/" className="flex items-center gap-3 group">
          <div className="relative h-10 w-10 rounded-full overflow-hidden flex-shrink-0">
            <Image
              src="/assets/images/colored-logo-1774222257519.png"
              alt="Ultra Luxury Cruise Club logo"
              width={40}
              height={40}
              className="object-cover w-full h-full" />
          </div>
          <div className="hidden sm:flex flex-col leading-tight">
            <span className="text-white text-sm font-semibold tracking-[0.15em] uppercase" style={{fontFamily: 'Georgia, "Times New Roman", serif'}}>Ultra Luxury</span>
            <span className="text-white text-sm font-semibold tracking-[0.12em] uppercase" style={{fontFamily: 'Georgia, "Times New Roman", serif', letterSpacing: '0.15em'}}>Cruise Club</span>
          </div>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navLinks?.map((link) =>
          <a
            key={link?.label}
            href={link?.href}
            className="text-white/70 hover:text-gold text-sm tracking-[0.08em] uppercase font-light transition-all duration-300 relative group">
            
              {link?.label}
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-gold group-hover:w-full transition-all duration-300" />
            </a>
          )}
        </nav>

        {/* CTA */}
        <div className="hidden md:flex items-center gap-4">
          <a
            href="#join"
            className="px-6 py-2.5 bg-gold-gradient text-navy-dark text-sm font-medium tracking-[0.1em] uppercase rounded-sm hover:shadow-lg hover:shadow-gold/20 transition-all duration-300 hover:-translate-y-0.5">
            
            Join The Club
          </a>
        </div>

        {/* Mobile Menu Button */}
        <button
          className="md:hidden text-white p-2"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu">
          
          <div className={`w-6 h-0.5 bg-white mb-1.5 transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-2' : ''}`} />
          <div className={`w-6 h-0.5 bg-white mb-1.5 transition-all duration-300 ${menuOpen ? 'opacity-0' : ''}`} />
          <div className={`w-6 h-0.5 bg-white transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-2' : ''}`} />
        </button>
      </div>
      {/* Mobile Menu */}
      {menuOpen &&
      <div className="md:hidden bg-navy-dark/98 backdrop-blur-md border-t border-gold/10 px-6 py-6">
          {navLinks?.map((link) =>
        <a
          key={link?.label}
          href={link?.href}
          className="block text-white/70 hover:text-gold py-3 text-sm tracking-[0.1em] uppercase font-light border-b border-white/5 transition-colors duration-200"
          onClick={() => setMenuOpen(false)}>
          
              {link?.label}
            </a>
        )}
          <a
          href="#join"
          className="mt-4 block text-center px-6 py-3 bg-gold-gradient text-navy-dark text-sm font-medium tracking-[0.1em] uppercase rounded-sm"
          onClick={() => setMenuOpen(false)}>
          
            Join The Club
          </a>
        </div>
      }
    </header>);

}